module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAPCAYAAADUFP50AAAAoUlEQVQokWP8DwQMZACW7de/MqStfMXw5ONvsIAMPyvDrHAxBk9NbgZ8cowy9ff+wyRgAKTgcYMig2zDfQZcckzoEiAAE4PR//vVwBhZjIkc/4H9CLIam63IgLHwFopTwTaCPAvjEAKwwAEbRrXogAFQYCA7EdlGUHQwYdOEC4DUgdSDANboIKQZrJEkXUiACVuIwsTwyWFEB3KQ45MjOzoAn/NhcRq7lkIAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./static/workoff/excelimg/sougou/jptb1-1.png
// module id = 910
// module chunks = 0